module.exports = __webpack_public_path__ + "bs.svg?cf40c6afb10d012e938c1fc4975301db";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/bs.svg
// module id = 1272
// module chunks = 0